import { useEffect, useRef, useState } from "react";
import InputTime from "./components/InputTime";
import SelectTime from "./components/SelectTime";

const { TextData } = require("views/components/Schedules/components/UpdateActivityPopup/styles")

const DatePicker = ({
    textData,
    value,
    setValue
}) => {
    const containerRef = useRef(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            containerRef.current &&
            !containerRef.current.contains(event.target)
            ) {
            setOpen(false); 
            }
        };
        window.addEventListener("mousedown", handleClickOutside);

        return () => {
            window.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleOpenOptions = () =>{
        setOpen(true);
    }

    return (
        <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
            <TextData>{textData}</TextData>
            <InputTime
                value={value}
                onClick={handleOpenOptions}
            />
            <SelectTime
                show={open}
                setOpen={setOpen}
                value={value}
                setTime={setValue}
            />
        </div>
    )
}

export default DatePicker;